export default{S:{avatarSize:"32px",fontSize:"M"},M:{avatarSize:"40px",fontSize:"L"},L:{avatarSize:"56px",fontSize:"XXL"},XL:{avatarSize:"96px",fontSize:"XXXL"},defaults:{avatarSize:"S"}};
